import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-file-input-dialog",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatButton],
    templateUrl: "./file-input-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileInputDialogComponent {
    private _selfRef: MatDialogRef<FileInputDialogComponent> = inject(
        MatDialogRef<FileInputDialogComponent>,
    );

    public data: { accept: string } = inject(MAT_DIALOG_DATA);

    public form: FormGroup<{ file: FormControl<File> }> = new FormGroup<{
        file: FormControl<File>;
    }>({
        file: new FormControl<File>(null!, {
            nonNullable: true,
            validators: [Validators.required],
        }),
    });

    public onFileUploaded(event: Event): void {
        const fileInput: HTMLInputElement | null = event.target as HTMLInputElement;

        if (fileInput && fileInput.files) {
            const file: File = fileInput.files[0];

            this.form.controls.file.setValue(file);
        }
    }

    public close(): void {
        this._selfRef.close(this.form.getRawValue().file);
    }
}
